export default {
  MIELE: 'miele',
};
